import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { startApp } from './app/lifecycle'
import { captureInstallPrompt, installPlatform, mustInstall, reloadWhenInstalled } from './features/install/installGate'
import { InstallScreen } from './features/install/InstallScreen'
import { UpdatePrompt } from './features/shell/UpdatePrompt'
import { reportKeyboard, startViewportHeight } from './app/viewportHeight'
import { playOneAtATime } from './features/media/playback'
import { startNativeKeyboard } from './native/keyboard'
import { startTheme } from './features/settings/AppearanceSection'
import { soundPlayer } from './sound/player'
import './styles/index.css'

// Light or dark, as this device was left: the page is marked before anything is drawn.
startTheme()
// The app is drawn in what a keyboard leaves of the screen, not in the whole of it.
startViewportHeight()
// Inside the iOS app the keyboard plugin says how tall the keyboard will be as it starts to rise.
startNativeKeyboard(reportKeyboard)
// Browsers allow audio only after a user gesture: unlock on the first tap or key press.
soundPlayer.attach()
// Starting a video or audio clip pauses any other.
playOneAtATime()
captureInstallPrompt()

const root = createRoot(document.getElementById('root')!)
const platform = installPlatform()
if (platform && mustInstall()) {
  // A phone's browser: nothing signs in or syncs here. The service worker still registers (UpdatePrompt), so the page stays installable.
  reloadWhenInstalled()
  root.render(
    <StrictMode>
      <InstallScreen platform={platform} />
      <UpdatePrompt />
    </StrictMode>,
  )
} else {
  void startApp()
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
